export default __webpack_public_path__ + "static/media/exultationofxotli.bf79f571.png";